import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

export const QuickCalculatorTileSkeleton: FC = () => {
	const { dashboard } = useTheme();
	const { tile } = dashboard.quickCalculator;

	return (
		<Stack alignItems="center" flexShrink={0} width={tile.width}>
			<Skeleton
				variant="circular"
				animation="wave"
				width={tile.circleSize}
				height={tile.circleSize}
			/>
			<Stack alignItems="center" width="100%" pt={tile.labelGap}>
				<Skeleton
					variant="text"
					animation="wave"
					width="80%"
					height={tile.skeletonLineHeight}
				/>
				<Skeleton
					variant="text"
					animation="wave"
					width="55%"
					height={tile.skeletonLineHeight}
				/>
			</Stack>
		</Stack>
	);
};
